import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {connect} from 'react-redux';
import {change, Field} from 'redux-form';
import {
    TextInput
} from 'admin-on-rest';
import {viewStyles} from '../shared/styles-view';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';

/**
 * A filter component with a text input
 */
class SearchFilterTextInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowSubmit: false,
            searchTerm: ''
        };
    }

    componentDidMount() {
        const input = this.props.input;
        if (input && input.value && input.value.length > 2) {
            // If the Search input is filled upon return to the page, allow submission
            if (this.props.formReference && this.props.source) {
                this.props.dispatch(change(this.props.formReference, this.props.source, input.value));
                this.props.dispatch(change(this.props.formReference, this.props.source + '_input', input.value));
                this.props.dispatch(change(this.props.formReference, this.props.source + '_submit', false));
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        // If other filters are updated that should clear this field:
        let filterChanged = false;
        const clearOnFilter = this.props.clearOnFilter;
        if (typeof clearOnFilter === 'string') {
            if (nextProps[clearOnFilter] !== this.props[clearOnFilter]) {
                filterChanged = true;
            }
        }
        if (typeof clearOnFilter === 'object' && clearOnFilter.length > 0) {
            for (let i = 0; i < clearOnFilter.length; i++) {
                if (nextProps[clearOnFilter[i]] !== this.props[clearOnFilter[i]]) {
                    filterChanged = true;
                    break;
                }
            }
        }
        if (filterChanged) {
            this.resetSearch();
        }
    }

    resetSearch = () => {
        this.setState({
            allowSubmit: false,
            searchTerm: ''
        });
        this.props.dispatch(change(this.props.formReference, this.props.source, ''));
        this.props.dispatch(change(this.props.formReference, this.props.source + '_input', ''));
        this.props.dispatch(change(this.props.formReference, this.props.source + '_submit', false));
    };

    handleInputUpdate = (e, v) => {
        this.setState({
            allowSubmit: false,
            searchTerm: v
        });
        this.props.dispatch(change(this.props.formReference, this.props.source, v));
        this.props.dispatch(change(this.props.formReference, this.props.source + '_submit', false));
    };

    handleSubmit = () => {
        this.setState({
            allowSubmit: true
        });

        this.props.dispatch(change(this.props.formReference, this.props.source + '_submit', true));
    };

    render() {
        const {
            buttonLabel,
            input,
            label,
            loading,
            source
        } = this.props;

        const {
            allowSubmit,
            searchTerm
        } = this.state;

        const term = (input && input.value) ? input.value : searchTerm;

        return (
            <span>
                <Field
                    id={`${source}_input`}
                    name={`${source}_input`}
                    component={TextInput}
                    label={label}
                    onChange={(e, v) => this.handleInputUpdate(e, v)}
                    style={viewStyles.filterInline}
                    elStyle={viewStyles.filterSearch}
                />
                <Field
                    id={source}
                    name={source}
                    component={TextInput}
                    label=""
                    style={viewStyles.hidden}
                    elStyle={viewStyles.hidden}
                />
                <RaisedButton
                    primary
                    label={buttonLabel}
                    disabled={(term === '' || term.length < 3 || loading)}
                    onClick={() => this.handleSubmit()}
                    style={{...viewStyles.filterInline, ...viewStyles.filterButton}}
                />
                {allowSubmit && loading &&
                    <CircularProgress
                        size={24}
                        thickness={2}
                        className="loader"
                        style={viewStyles.filterLoading}
                    />
                }
                <hr style={viewStyles.break}/>
            </span>
        );
    }
}

function mapStateToProps(state, props) {
    const loading = !!(state.admin && state.admin.loading);
    const clearOnFilter = props.clearOnFilter;
    if (clearOnFilter && props.formReference) {
        let formState = state.form[props.formReference];
        let formValues = (formState && formState.values) ? formState.values : {};
        if (formState && formValues) {
            let obj = {
                loading: loading
            };
            // Store a single clearing filter
            if (typeof clearOnFilter === 'string') {
                if (formValues[clearOnFilter]) {
                    obj[clearOnFilter] = formValues[clearOnFilter];
                }
            }
            // Store each of several clearing filters
            if (typeof clearOnFilter === 'object' && clearOnFilter.length > 0) {
                for (let i = 0; i < clearOnFilter.length; i++) {
                    if (formValues[clearOnFilter[i]]) {
                        obj[clearOnFilter[i]] = formValues[clearOnFilter[i]];
                    }
                }
            }
            return obj;
        }
    }
    return {};
}

SearchFilterTextInput.propTypes = {
    addLabel: PropTypes.bool,
    buttonLabel: PropTypes.string,
    clearOnFilter: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
    ]),
    formReference: PropTypes.string,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    loading: PropTypes.bool,
    source: PropTypes.string,
};

SearchFilterTextInput.defaultProps = {
    addLabel: true,
    buttonLabel: 'Search',
    formReference: null,
    isRequired: false,
    loading: false
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(SearchFilterTextInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/SearchFilterTextInput.js